import { formatCurrency } from '@utils'
import cn from 'clsx'

const CheckDetailsWellsTable = ({
    className,
    wells,
}) => {
    
    return (
        
        <table className={cn('CheckDetailsWellsTable table-auto', className)}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>API Number</th>
                    <th>County</th>
                    <th>State</th>
                    <th>Owner Gross</th>
                    <th>Owner Adjustments</th>
                    <th>Owner Net</th>
                </tr>
            </thead>
            <tbody>
                {wells?.rows?.map(it => (
                    <tr key={it.property}>
                        <td>{it.property ?? ''}</td>
                        <td>{it.apiNumber ?? ''}</td>
                        <td>{it.county ?? ''}</td>
                        <td>{it.state ?? ''}</td>
                        <td>{formatCurrency(it.gross ?? 0)}</td>
                        <td>{formatCurrency(it.adjustments ?? 0)}</td>
                        <td>{formatCurrency(it.net ?? 0)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    )
    
}

export default CheckDetailsWellsTable
